// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"165":"css/indicators","252":"css/app","488":"css/print","949":"css/qr2ur"}[chunkId] + ".css";
};